import { watchInitApp } from './initApp';

export const coreSagas = [watchInitApp()];
